<template>
  <div class="not-found">
    <svg
      width="120"
      height="104"
      viewBox="0 0 120 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1_32899)">
        <path
          d="M26.1757 32.7304C25.8873 32.7279 25.5999 32.6962 25.3178 32.636C19.9042 31.4864 18.8747 19.561 18.6602 15.9319C18.6062 15.6887 18.6059 15.4365 18.6592 15.1931C18.7125 14.9497 18.8182 14.7208 18.9689 14.5223C19.1196 14.3239 19.3118 14.1607 19.532 14.044C19.7522 13.9273 19.9952 13.86 20.244 13.8468C20.4928 13.8335 20.7416 13.8746 20.9729 13.9672C21.2043 14.0598 21.4127 14.2017 21.5837 14.383C21.7546 14.5643 21.8841 14.7806 21.963 15.017C22.0418 15.2534 22.0683 15.5041 22.0405 15.7518C22.3665 21.8431 24.0824 28.9211 26.0127 29.3244C26.253 29.3758 28.5093 29.5646 33.1765 20.4361C33.2501 20.1968 33.3752 19.9765 33.543 19.7906C33.7107 19.6048 33.9171 19.4579 34.1477 19.3603C34.3783 19.2626 34.6274 19.2167 34.8777 19.2256C35.1279 19.2345 35.3731 19.298 35.5962 19.4118C35.8192 19.5255 36.0147 19.6867 36.1688 19.884C36.323 20.0814 36.4321 20.31 36.4884 20.554C36.5448 20.7979 36.5471 21.0512 36.4952 21.2962C36.4433 21.5411 36.3384 21.7717 36.1879 21.9718C32.4644 29.2729 29.2557 32.7304 26.1757 32.7304Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.56"
          stroke-miterlimit="10"
        />
        <path
          d="M21.56 10.7242C21.622 10.9162 21.7495 11.0803 21.9204 11.1875C22.2537 11.382 22.5261 11.6658 22.7065 12.0069C22.8869 12.3481 22.9683 12.7329 22.9413 13.1179C22.9413 14.7823 20.6592 17.3132 18.746 17.3132C16.8328 17.3132 16.3009 16.6354 16.3009 15.8976C16.3009 15.1598 1.50142 19.4666 1.02955 12.1227C1.03295 11.9153 0.973094 11.7118 0.857966 11.5393C0.582732 11.1707 0.392308 10.746 0.300305 10.2953C0.204273 9.88771 0.226742 9.4612 0.365066 9.06599C0.503389 8.67078 0.751803 8.32334 1.08103 8.06463C1.3826 7.81523 1.72916 7.62593 2.10198 7.50697C2.32066 7.45817 2.51157 7.32576 2.6339 7.13805C2.72368 6.99084 2.82404 6.85034 2.93418 6.71766C3.19534 6.46334 3.53072 6.29879 3.89168 6.24789C4.25265 6.19698 4.62045 6.26236 4.94176 6.43454C5.45652 6.60613 5.91981 6.89783 6.43457 7.06942C6.94934 7.24101 7.44694 7.44691 7.95313 7.60992C8.87135 7.95375 9.83885 8.14783 10.8186 8.18474C10.8427 8.18307 10.8661 8.17606 10.8872 8.16423C10.9082 8.1524 10.9264 8.13605 10.9404 8.11635C10.9543 8.09664 10.9637 8.07409 10.9679 8.0503C10.9721 8.02652 10.9709 8.00211 10.9645 7.97883C10.7314 7.25388 10.6582 6.487 10.75 5.73103C10.7837 5.47813 10.8765 5.23675 11.021 5.02649C11.1655 4.81623 11.3576 4.64303 11.5816 4.52098C11.8057 4.39893 12.0553 4.33147 12.3104 4.32408C12.5654 4.31668 12.8186 4.36957 13.0493 4.47844C13.3305 4.58792 13.5766 4.77178 13.7614 5.01036C13.9392 5.30457 14.0749 5.62223 14.1646 5.9541C14.2875 6.25379 14.4928 6.51257 14.7566 6.7005C15.1825 7.0013 15.6434 7.24907 16.1293 7.43833C16.7365 7.69578 17.3691 7.88845 18.0168 8.01315C18.6302 8.04176 19.2408 8.11343 19.8442 8.22764C20.8222 8.57939 21.2941 9.77193 21.56 10.7242Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.56"
          stroke-miterlimit="10"
        />
        <path
          d="M47.5385 67.8201C47.5385 67.8201 51.5279 67.7257 50.1123 71.8267C50.1123 71.8267 53.3982 88.7195 50.8501 91.1046C48.302 93.4897 31.1175 96.0635 31.1175 87.9903C31.1175 87.9903 31.6151 79.857 39.9371 79.857C39.9371 79.857 41.3527 72.3329 41.0524 71.9039C40.7522 71.4749 39.5081 71.2347 39.92 69.3301C40.3318 67.4255 43.8836 67.3225 43.8836 67.3225L47.5385 67.8201Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.56"
          stroke-miterlimit="10"
        />
        <path
          d="M45.1877 70.6599C44.3297 70.6599 44.0037 70.4626 43.9865 70.1623C43.8064 64.028 44.8445 58.0911 45.0504 57.8337C45.7048 57.4338 46.4841 57.2901 47.2381 57.4305C48.1819 57.5163 48.7224 57.8423 48.4564 58.1511C47.4956 61.996 47.1596 65.9704 47.4612 69.9221C47.4612 70.2652 46.5175 70.5741 45.5566 70.6427L45.1877 70.6599Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.56"
          stroke-miterlimit="10"
        />
        <path
          d="M40.0658 79.8313C40.0658 79.8313 47.1953 79.7626 49.0656 82.4051"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M69.107 67.8201C69.107 67.8201 65.1262 67.7257 66.5332 71.8267C66.5332 71.8267 63.2559 88.7195 65.7954 91.1046C68.3349 93.4897 85.528 96.0635 85.528 87.9903C85.528 87.9903 85.039 79.857 76.7084 79.857C76.7084 79.857 75.2928 72.3329 75.5931 71.9039C75.8933 71.4749 77.1373 71.2347 76.7255 69.3301C76.3137 67.4255 72.7619 67.3225 72.7619 67.3225L69.107 67.8201Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.56"
          stroke-miterlimit="10"
        />
        <path
          d="M71.4578 70.6599C72.3157 70.6599 72.6503 70.4626 72.6589 70.1623C72.8391 64.028 71.801 58.0911 71.6036 57.8337C70.9486 57.4353 70.1699 57.2918 69.4159 57.4305C68.4722 57.5163 67.9231 57.8423 68.1891 58.1511C69.1503 61.996 69.4891 65.97 69.1928 69.9221C69.1928 70.2652 70.1366 70.5741 71.0889 70.6427L71.4578 70.6599Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.56"
          stroke-miterlimit="10"
        />
        <path
          d="M92.9663 32.3443C89.8863 32.3443 86.6862 28.9126 82.9542 21.5858C82.8252 21.1967 82.8397 20.7743 82.9952 20.3951C83.1506 20.0158 83.4367 19.7047 83.8017 19.5181C84.1666 19.3315 84.5863 19.2817 84.9848 19.3777C85.3833 19.4737 85.7342 19.7091 85.9741 20.0415C90.6327 29.1699 92.8891 28.9898 93.1379 28.9383C95.0683 28.5265 96.7756 21.4485 97.1016 15.3571C97.1896 14.9606 97.4154 14.6081 97.7389 14.3624C98.0623 14.1168 98.4624 13.9938 98.8681 14.0154C99.2737 14.037 99.6584 14.2018 99.954 14.4805C100.249 14.7592 100.437 15.1336 100.482 15.5373C100.293 19.1664 99.2379 31.1003 93.8414 32.25C93.5537 32.311 93.2605 32.3427 92.9663 32.3443Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.56"
          stroke-miterlimit="10"
        />
        <path
          d="M76.5883 79.8313C76.5883 79.8313 69.4931 79.7884 67.5885 82.4308"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M32.6017 0.857939C33.288 10.2953 33.7685 20.0415 34.0173 30.1995C34.2747 40.6835 34.2747 50.77 34.0173 60.459L75.6874 61.4628L85.4679 55.2942L87.3725 1.98184C69.1773 0.105766 50.8586 -0.270135 32.6017 0.857939V0.857939ZM36.1965 9.30006C36.2563 9.00806 36.3944 8.73779 36.5958 8.51805C36.7972 8.29831 37.0544 8.13734 37.3401 8.0523C37.6258 7.96725 37.9292 7.96133 38.218 8.03514C38.5068 8.10896 38.7702 8.25976 38.98 8.47147C39.1899 8.68317 39.3383 8.94785 39.4096 9.23728C39.4808 9.52672 39.4722 9.83007 39.3847 10.115C39.2971 10.3999 39.1338 10.6557 38.9123 10.8552C38.6908 11.0547 38.4193 11.1903 38.1268 11.2476C37.866 11.2899 37.5987 11.2692 37.3475 11.1872C37.0963 11.1052 36.8684 10.9642 36.6828 10.7761C36.4971 10.588 36.3593 10.3581 36.2806 10.1058C36.202 9.85353 36.1849 9.58607 36.2308 9.3258L36.1965 9.30006ZM36.797 21.6544C36.8554 21.3616 36.9922 21.0902 37.1929 20.8692C37.3936 20.6481 37.6506 20.4858 37.9364 20.3995C38.2222 20.3132 38.5261 20.3063 38.8155 20.3793C39.105 20.4524 39.3692 20.6027 39.5798 20.8143C39.7904 21.0259 39.9396 21.2907 40.0114 21.5805C40.0832 21.8703 40.0748 22.1741 39.9873 22.4595C39.8997 22.745 39.7363 23.0012 39.5143 23.2009C39.2924 23.4006 39.0204 23.5363 38.7274 23.5933C38.4667 23.6394 38.1987 23.6216 37.9463 23.5414C37.694 23.4613 37.4648 23.3212 37.2785 23.1331C37.0921 22.9451 36.9541 22.7147 36.8762 22.4616C36.7983 22.2086 36.7829 21.9404 36.8313 21.6801L36.797 21.6544ZM40.2288 49.6318C40.1699 49.9235 40.0331 50.1939 39.833 50.4141C39.6328 50.6344 39.3767 50.7962 39.0918 50.8826C38.807 50.9689 38.5041 50.9764 38.2154 50.9044C37.9266 50.8324 37.6627 50.6835 37.4518 50.4735C37.2409 50.2635 37.0908 50.0003 37.0175 49.7119C36.9442 49.4234 36.9504 49.1205 37.0355 48.8353C37.1206 48.5501 37.2813 48.2933 37.5007 48.0921C37.72 47.891 37.9898 47.753 38.2812 47.6929C38.5528 47.6294 38.8361 47.636 39.1044 47.712C39.3728 47.7879 39.6174 47.9308 39.8155 48.1271C40.0136 48.3235 40.1585 48.5669 40.2368 48.8346C40.3151 49.1022 40.3241 49.3854 40.2631 49.6575L40.2288 49.6318ZM40.3231 35.2785C40.292 35.5017 40.2156 35.7163 40.0986 35.909C39.9816 36.1016 39.8265 36.2684 39.6428 36.399C39.4591 36.5297 39.2506 36.6214 39.0302 36.6687C38.8098 36.7159 38.5821 36.7176 38.361 36.6738C38.1398 36.6299 37.93 36.5413 37.7443 36.4135C37.5587 36.2857 37.401 36.1213 37.2811 35.9305C37.1612 35.7396 37.0815 35.5262 37.047 35.3035C37.0124 35.0807 37.0237 34.8533 37.0801 34.635C37.1516 34.3187 37.3112 34.0292 37.5405 33.7999C37.7698 33.5706 38.0593 33.411 38.3756 33.3395C38.6419 33.2868 38.9171 33.3003 39.177 33.3789C39.4368 33.4575 39.6734 33.5988 39.8658 33.7903C40.0581 33.9819 40.2005 34.2178 40.2803 34.4773C40.36 34.7368 40.3747 35.0119 40.3231 35.2785V35.2785Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.56"
          stroke-miterlimit="10"
        />
        <path
          d="M75.7131 61.4628C76.149 60.2108 76.4818 58.9254 76.7083 57.6192C76.9475 56.2363 77.0709 54.8359 77.0773 53.4325C78.463 54.0074 79.899 54.4526 81.367 54.7623C82.7395 55.056 84.1342 55.2339 85.5365 55.2942C84.078 56.3323 82.5166 57.3876 80.8522 58.4343C79.1878 59.4809 77.3604 60.5534 75.7131 61.4628Z"
          fill="#0077FF"
        />
        <path
          d="M41.4814 9.43734C54.7623 8.65661 73.8257 9.68614 87.0809 10.8444"
          stroke="#0077FF"
          stroke-width="1.13"
          stroke-miterlimit="10"
        />
        <path
          d="M41.7045 22.0061C42.3308 22.0061 73.1136 22.2035 86.6348 23.4132"
          stroke="#0077FF"
          stroke-width="1.13"
          stroke-miterlimit="10"
        />
        <path
          d="M42.0391 34.798C55.3114 34.0173 72.9249 34.9696 86.1972 36.1793"
          stroke="#0077FF"
          stroke-width="1.13"
          stroke-miterlimit="10"
        />
        <path
          d="M42.3908 49.5203C55.6975 48.7481 72.4187 49.7433 85.6481 50.9959"
          stroke="#0077FF"
          stroke-width="1.13"
          stroke-miterlimit="10"
        />
        <path
          d="M40.6835 0.47187C41.4299 9.96926 41.8331 18.1454 42.1077 28.5522C42.3994 39.7569 42.3565 50.4812 42.0476 60.6649"
          stroke="#0077FF"
          stroke-width="0.56"
          stroke-miterlimit="10"
        />
        <path
          d="M45.6938 7.18095C45.9135 6.81898 46.1725 6.48235 46.466 6.17716C46.7295 5.8696 47.0164 5.58277 47.3239 5.31923C47.928 4.82635 48.5839 4.4006 49.28 4.04947C49.9802 3.68756 50.7163 3.40001 51.4764 3.19154C51.8708 3.08433 52.2721 3.00407 52.6775 2.95131C53.1338 2.90085 53.5945 2.90373 54.0502 2.95989L54.1102 3.07142L53.0893 3.62908L52.0512 4.16101L49.9406 5.24201L47.8559 6.28012L46.8092 6.79488L45.7539 7.29249L45.6938 7.18095Z"
          fill="#0077FF"
        />
        <path
          d="M57.5591 32.1985C61.6944 34.1117 69.0555 34.6693 74.0059 29.6933"
          stroke="#0077FF"
          stroke-width="0.76"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M73.0192 28.9726C73.0192 28.9726 74.3919 29.1013 74.1774 31.0231"
          stroke="#0077FF"
          stroke-width="0.76"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M65.4007 3.25159C65.8226 3.20406 66.2486 3.20406 66.6705 3.25159C67.0691 3.30277 67.4645 3.37725 67.8544 3.47466C68.6086 3.68432 69.3389 3.97185 70.0336 4.3326C70.7523 4.67634 71.4337 5.09321 72.0669 5.57661C72.3854 5.84583 72.689 6.13224 72.9763 6.43455C73.2738 6.73582 73.5437 7.06314 73.7828 7.4126L73.7313 7.53271L72.6675 7.04368L71.6208 6.52892L69.4931 5.50797L67.4169 4.45271L66.3788 3.92079L65.3492 3.3717L65.4007 3.25159Z"
          fill="#0077FF"
        />
        <path
          d="M97.4362 11.6594C97.3772 11.8554 97.2452 12.0213 97.0673 12.1227C96.7432 12.3241 96.4807 12.6106 96.3082 12.951C96.1358 13.2914 96.06 13.6726 96.0893 14.053C96.0893 15.7174 98.38 18.2484 100.293 18.2484C102.206 18.2484 102.704 17.5706 102.704 16.8328C102.704 16.0949 117.538 20.3932 118.001 13.0493C118.015 12.8409 118.09 12.6411 118.216 12.4744C118.472 12.1087 118.65 11.694 118.739 11.2562C118.833 10.8499 118.81 10.4251 118.672 10.0316C118.533 9.63813 118.286 9.29213 117.958 9.0341C117.654 8.78445 117.304 8.59518 116.929 8.47644C116.712 8.42351 116.524 8.28809 116.405 8.09895C116.313 7.95414 116.21 7.81648 116.096 7.68714C115.84 7.42913 115.508 7.25934 115.149 7.20228C114.789 7.14522 114.421 7.20385 114.097 7.3697C113.583 7.54129 113.111 7.82441 112.596 7.99599C112.081 8.16758 111.592 8.37349 111.077 8.54507C110.162 8.88959 109.198 9.08371 108.221 9.11989C108.195 9.11855 108.171 9.11143 108.149 9.0991C108.127 9.08676 108.109 9.06954 108.094 9.04878C108.08 9.02802 108.071 9.00428 108.068 8.97941C108.064 8.95454 108.067 8.92922 108.075 8.90541C108.305 8.18285 108.376 7.41869 108.281 6.66619C108.246 6.41454 108.153 6.17446 108.009 5.96512C107.865 5.75577 107.674 5.58295 107.452 5.46043C107.229 5.33792 106.981 5.26911 106.727 5.25949C106.474 5.24986 106.221 5.2997 105.99 5.40502C105.707 5.52059 105.459 5.70668 105.269 5.94552C105.086 6.23209 104.939 6.54048 104.832 6.86351C104.708 7.16494 104.503 7.42624 104.24 7.6185C103.813 7.91761 103.352 8.16526 102.867 8.35633C102.273 8.60698 101.655 8.7967 101.022 8.92257C100.409 8.95777 99.7987 9.03227 99.195 9.14563C98.1741 9.50597 97.7022 10.7071 97.4362 11.6594Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.56"
          stroke-miterlimit="10"
        />
        <path
          d="M107.989 9.06842C107.028 9.48061 105.958 9.56797 104.943 9.31722"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M116.525 8.39065C114.887 8.06463 110.932 11.4964 109.138 10.9645"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M117.95 12.6375C117.484 12.2318 116.918 11.9591 116.311 11.8481C115.681 11.8371 115.062 12.0165 114.535 12.3629C113.939 12.6955 113.309 12.963 112.656 13.1608C111.987 13.3081 111.307 13.3999 110.623 13.4353"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M108.795 10.4926C108.795 10.4926 111.223 13.6069 110.623 14.2761"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M100.327 12.9635C100.327 12.9635 103.296 11.4192 105.578 12.9635"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M11.0074 8.13327C11.9682 8.5467 13.0379 8.63409 14.0531 8.38207"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M2.47089 7.4555C4.10097 7.13806 8.06465 10.5612 9.84917 10.0293"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M1.04669 11.7023C1.51198 11.2966 2.07809 11.0239 2.68536 10.913C3.31495 10.9071 3.93244 11.0861 4.46129 11.4278C5.05641 11.7619 5.6865 12.0294 6.34018 12.2256C7.00925 12.3729 7.68933 12.4647 8.3735 12.5002"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M10.2009 9.55745C10.2009 9.55745 7.77291 12.6718 8.37347 13.341"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M18.6602 12.0112C18.6602 12.0112 15.7003 10.4669 13.4182 12.0112"
          stroke="#0077FF"
          stroke-width="0.21"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M69.1414 28.1147C72.2971 28.1147 74.8552 24.9227 74.8552 20.9852C74.8552 17.0477 72.2971 13.8557 69.1414 13.8557C65.9857 13.8557 63.4275 17.0477 63.4275 20.9852C63.4275 24.9227 65.9857 28.1147 69.1414 28.1147Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.65"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M69.1413 23.5848C70.3117 23.5848 71.2604 22.3441 71.2604 20.8136C71.2604 19.2831 70.3117 18.0425 69.1413 18.0425C67.971 18.0425 67.0222 19.2831 67.0222 20.8136C67.0222 22.3441 67.971 23.5848 69.1413 23.5848Z"
          fill="#0077FF"
        />
        <path
          d="M69.5445 19.9642C70.0468 19.9642 70.454 19.5571 70.454 19.0548C70.454 18.5526 70.0468 18.1454 69.5445 18.1454C69.0423 18.1454 68.6351 18.5526 68.6351 19.0548C68.6351 19.5571 69.0423 19.9642 69.5445 19.9642Z"
          fill="white"
        />
        <path
          d="M64.4913 16.8499H73.637"
          stroke="#0077FF"
          stroke-width="0.65"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M49.4774 27.7458C52.6331 27.7458 55.1912 24.5538 55.1912 20.6163C55.1912 16.6788 52.6331 13.4868 49.4774 13.4868C46.3217 13.4868 43.7635 16.6788 43.7635 20.6163C43.7635 24.5538 46.3217 27.7458 49.4774 27.7458Z"
          fill="white"
          stroke="#0077FF"
          stroke-width="0.65"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M49.4774 23.2158C50.6477 23.2158 51.5965 21.9752 51.5965 20.4447C51.5965 18.9142 50.6477 17.6736 49.4774 17.6736C48.307 17.6736 47.3583 18.9142 47.3583 20.4447C47.3583 21.9752 48.307 23.2158 49.4774 23.2158Z"
          fill="#0077FF"
        />
        <path
          d="M49.8806 19.5953C50.3829 19.5953 50.79 19.1882 50.79 18.6859C50.79 18.1837 50.3829 17.7765 49.8806 17.7765C49.3783 17.7765 48.9712 18.1837 48.9712 18.6859C48.9712 19.1882 49.3783 19.5953 49.8806 19.5953Z"
          fill="white"
        />
        <path
          d="M54.4791 17.1759H44.467"
          stroke="#0077FF"
          stroke-width="0.65"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path d="M106 53H14V95H106V53Z" fill="#0077FF" />
        <path
          d="M60.0215 53.4325L60 95"
          stroke="white"
          stroke-width="0.56"
          stroke-miterlimit="10"
          stroke-linecap="square"
        />
        <path
          d="M60.0215 53.4325L46.0199 67.4426H0.0429077L13.8386 53.4325H60.0215Z"
          fill="#72b4ff"
        />
        <path
          d="M120 67.4426H74.023L60.0214 53.4325H106.144L120 67.4426Z"
          fill="#72b4ff"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_32899">
          <rect width="120" height="103.373" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    type: [String],
    text: [String],
  },
};
</script>
